module.exports = __webpack_public_path__ + "img/desktop/Background-freespins/fsbackground@2x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Background-freespins/fsbackground@2x.jpg
// module id = 173
// module chunks = 0